import { owcTheme } from 'core/theme/theme.config';
import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { ModalDialog } from 'commons/components';
import styled from 'styled-components';

export const EapSettingsImportingCard = styled(PocCard)`
    width: 100%;
    max-width: 760px;

    /* OWC-OVERRIDE: stack the import steps with the card's v6 padding. owc-card's content
       wrapper is a plain block with zero padding in v7.6.0 and exposes no layout or padding
       prop. */
    .owc-card__content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding: 1rem 1.5rem;
    }
`;

export const EapSettingsImportingTitle = styled(PocTypography)`
    font-weight: 500 !important;
    color: ${owcTheme['one-color-foreground-base']} !important;
`;

export const EapSettingsImportingAssignRow = styled.div`
    width: 100%;
`;

export const EapSettingsImportingAssignSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const EapSettingsImportingFieldSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    &:not(:last-child) {
        margin-bottom: 0.25rem;
    }
`;

export const EapSettingsImportingMappingRow = styled.div`
    display: grid;
    grid-template-columns: 96px minmax(260px, 1fr);
    gap: 1rem;
    align-items: start;
`;

export const EapSettingsImportingControlsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const EapSettingsImportingRadioWrapper = styled.div`
    width: 100%;
    padding-top: 0.25rem;

    owc-radio-group {
        row-gap: 0.75rem;
        width: 100%;
    }
`;

export const EapSettingsImportingFieldControl = styled.div`
    width: 100%;

    > * {
        width: 100%;
    }
`;

export const EapSettingsImportingCertificatesModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const EapSettingsImportingCertificatesModalTitle = styled(PocTypography)`
    font-weight: 500 !important;
    color: ${owcTheme['one-color-foreground-base']} !important;
`;

export const EapSettingsImportingCertificatesModalDescription = styled(PocTypography)`
    color: ${owcTheme['one-color-gray-700']} !important;
`;

export const EapSettingsImportingCertificatesProgressRow = styled.div`
    margin-top: 0.25rem;
`;

export const EapSettingsImportingAbortModalDescription = styled.div`
    padding: 0.5rem 0;
`;

export const EapSettingsImportingConfirmationModalContent = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
`;

export const EapSettingsImportingMissingCertificatesList = styled.ul`
    max-width: 100%;
    padding: 0;
    margin: 0.5rem 0 0 0.5rem;
    list-style: none;

    li {
        position: relative;
        padding-left: 1rem;
        margin: 0.25rem 0;
    }

    li::before {
        position: absolute;
        top: 0.6em;
        left: 0;
        width: 4px;
        height: 4px;
        content: '';
        background-color: ${owcTheme['one-color-interaction-default-intensity-medium']};
        border-radius: 50%;
    }

    li owc-typography {
        line-height: 1.5;
        color: ${owcTheme['one-color-interaction-default-intensity-medium']};
        overflow-wrap: anywhere;
    }
`;

export const EapSettingsImportingUploadedFileName = styled.div`
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
`;

export const EapSettingsImportingMissingCertificatesModal = styled(ModalDialog)`
    && owc-card {
        width: min(760px, calc(100vw - 2rem));
        max-width: min(760px, calc(100vw - 2rem));
    }
`;

export const EapSettingsImportingAbortModal = styled(ModalDialog)`
    && owc-card {
        width: min(540px, calc(100vw - 2rem));
        max-width: min(540px, calc(100vw - 2rem));
    }
`;
